import React from 'react';

/** Table header cell shared across the voucher list and audit tables. */
export function Th({ children }: { children: React.ReactNode }) {
  return <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-gray-500">{children}</th>;
}

/** Labeled field wrapper used inside the create-voucher form. */
export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1.5">{label}</label>
      {children}
    </div>
  );
}
